import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import ContentNoticesSummary from './ContentNoticesSummary';

import './ContentNotices.scss';

export default function ContentNotices({ summary }) {
  const total = summary.getIn(['contentAdvisories', 'total']);

  return total ? (
    <div className="cp-content-notices" data-key="content-notices">
      <FormattedMessage tagName="h3" id="ugc_content_advisories" />
      <ContentNoticesSummary summary={summary} />
    </div>
  ) : null;
}

ContentNotices.propTypes = {
  summary: ImmutablePropTypes.map.isRequired
};
